import { IncomingMessage } from "./incoming-message";
/**
 * Incoming request message.
 * @public
 */
export class IncomingRequestMessage extends IncomingMessage {
    constructor() {
        super();
    }
}
